import { render, staticRenderFns } from "./FocusAreasSelect.vue?vue&type=template&id=4086eff1&scoped=true&"
import script from "./FocusAreasSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./FocusAreasSelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FocusAreasSelect.vue?vue&type=style&index=0&id=4086eff1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086eff1",
  null
  
)

export default component.exports